import { render, staticRenderFns } from "./Curriculums.vue?vue&type=template&id=8a99a15e&scoped=true&lang=pug"
import script from "./Curriculums.vue?vue&type=script&lang=js"
export * from "./Curriculums.vue?vue&type=script&lang=js"
import style0 from "./Curriculums.vue?vue&type=style&index=0&id=8a99a15e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a99a15e",
  null
  
)

export default component.exports